import { BasicPage } from "../components/BasicPage";
import Home from "@mui/icons-material/Home";

const HomePage = () => {
  return <BasicPage title="Home Page" icon={<Home />} />;
};

export default HomePage;
